export const demoValues = {
  socialDataAndChargesIsValidated: false,
  companyCnpj: "49.718.808/0001-06",
  companyName: "Empresa Desenvolvedora LTDA",
  taxRegime: { value: "simples_nacional", label: "Simples nacional" },
  mainCnae: { value: "1610203", label: "1610203 - SERRARIAS COM DESDOBRAMENTO DE MADEIRA EM BRUTO" },
  companyHasAgreements: "2",
  emitBoletoSeparately: "2",
  codigoTerceiros: null,
  isEmpresaCidada: "2",
  hasCollectiveVacation: "2",
  collectiveVacationPeriod: "Dezembro a Janeiro",
  collectiveVacationDays: "15",
  collectiveVacationByCostCenter: "2",
  collectiveVacationOtherRule: "Não se aplica",

  admissionIsValidated: false,
  trialContractTerm: "1",
  trialContractTermFirst: "45",
  trialContractTermSecond: "45",
  trialContractTermOther: "Nenhum",
  hasSpecificRegistrationRules: "2",
  specificRegistrationRulesDescription: "Não possui",
  useSamePayrollRegistrationForTimeTracking: "1",
  workTimeControl: "1",
  timeTrackingClosePeriod: "1",
  timeTrackingClosePeriodOther: "31/01",
  hasBankOfHours: "2",
  bankOfHoursFrequency: "Mensal",
  bankOfHoursCompetencies: ["Janeiro", "Fevereiro"],

  payrollIsValidated: false,
  calendarDefaultValues: [],
  ...[1, 2, 3, 4, 5, 6, 7, 8, 9].reduce((acc, id) => {
    acc[`notApplicable-${id}`] = true;
    acc[`paymentDay-${id}`] = "5";
    return acc;
  }, {}),
  anticipatePaymentsOnWeekendsHolidays: "1",
  anticipatePaymentsDescription: "Antecipa para o dia útil anterior",
  hasMonthlyAdvance: "2",
  advancePercentage: "40",
  advanceCalcBase: "1",
  advanceCalcBaseForCommissioned: "1",
  advanceCalcBaseForCommissionedOther: "Nenhum",
  minDaysWorkedForAdvance: "15",
  advancePaymentCalculationType: "1",
  newHiresReceiveAdvance: "2",
  advanceAdhesionNextMonth: "1",
  maternityLeaveReceiveAdvance: "2",
  proLaboreReceiveAdvance: "2",
  internReceiveAdvance: "2",
  apprenticeReceiveAdvance: "2",
  irrfAdvanceRetentionRule: "1",
  irrfAdvanceRetentionRuleOther: "Regra padrão",
  advanceAnalyticalReportOrder: "1",
  advanceNetReport: "1",
  advanceNetReportExcel: "1",
  thirteenthFirstInstallmentWriteOff: "1",
  vacationWriteOffMethod: "1",
  resignationProvisionWhenTerminated: "1",
  provisionAnalyticalReportOrder: "1",
  provisionSyntheticReportOrder: "1",
  provisionAccountingSyntheticReportOrder: "1",
  thirteenthAdvanceOnBirthday: "2",
  thirteenthFirstInstallmentWithAverages: "1",
  thirteenthFirstInstallmentWithAveragesOther: "Nenhum",
  internProLaboreThirteenth: "2",
  internProLaboreThirteenthRubricsNovDec: "1",
  internProLaboreThirteenthRubricsDecReceive: "Nenhuma",
  internProLaboreThirteenthRubricsDecOnly: "Nenhuma",
  internProLaboreThirteenthOtherRule: "Nenhuma",
  thirteenthAnalyticalReportOrder: "1",
  thirteenthSyntheticReportOrder: "1",
  thirteenthNetReport: "1",
  thirteenthNetReportExcel: "1",
  hasPlr: "2",
  plrAccordingToCctAct: "2",
  plrBusinessRule: "Regra de PLR padrão",
  plrFrequencyAndCompetencies: "1",
  plrSameCalendarYear: ["Dezembro"],
  plrAnalyticalReportOrder: "1",
  plrSyntheticReportOrder: "1",
  plrNetReport: "1",
  plrNetReportExcel: "1",
  plrAccountingSyntheticReportOrder: "1",
  hasConsignedLoan: "2",
  consignedLoanDeductionLaw: "1",
  consignedLoanDeductionOther: "Nenhuma",
  consignedLoanFullDeductionIfNoBalance: "1",
  consignedLoanFullDeductionIfNoBalanceOther: "Nenhuma",
  consignedLoanFormat: "1",
  consignedLoanDataReceptionDate: "Dia 20",

  bankCommunicationIsValidated: false,
  hasBankTransferFile: "2",
  bankFileLayoutD1: "1",
  bankSequentialNumberRule: "1",
  issueUnifiedBankFile: "2",
  bankAccounts: [
    {
      cnpj: "49.718.808/0001-06", bank: "001", agency: "1234", account: "12345-6", agreementCode: "123",
    },
  ],
  specificPaymentRule: "2",
  specificPaymentRuleDescription: "Nenhuma",

  businessRuleIsValidated: false,
  collectiveAgreementType: "1",
  applyCollectiveAgreementRules: "1",
  collectiveAgreementPartialClauses: "Nenhuma",
  applyCollectiveAgreementRulesOther: "Nenhuma",
  vacationAdvanceDiscounts: "2",
  vacationAdvanceDiscountsList: "Nenhum",
  vacationDiscountConditions: "Nenhuma",
  vacationAverages: "1",
  vacationAveragesOther: "Nenhuma",
  vacationBenefits: "2",
  vacationBenefitsList: "Nenhum",
  vacationBenefitsDescription: "Nenhum",
  terminationDiscounts: [{ value: "1", label: "Plano de Saúde" }],
  terminationDiscountsOther: "Nenhum",
  loanDiscountPercentageTermination: "1",
  loanDiscountPercentageTerminationOther: "Nenhum",
  terminationAverages: "1",
  terminationAveragesOther: "Nenhuma",
  payrollHasInterns: "2",
  internSalaryAdjustmentRule: "1",
  internSalaryAdjustmentOther: "Nenhuma",
  internHasDeductions: "2",
  internDeductionsDescription: "Nenhuma",
  internHasBenefits: "2",
  interBenefitsCalculation: "2",
  interPayrollProcessing: "2",
  internFixedBenefit: "2",
  internFixedBenefitRubric: "Nenhuma",
  internFixedBenefitRule: "Nenhuma",
  internBenefitValue: "1",
  internProportionalCalcRule: "1",
  internProportionalCalcRuleOther: "Nenhuma",
  payrollHasApprentices: "2",
  apprenticeSalaryAdjustmentRule: "1",
  apprenticeSalaryAdjustmentOther: "Nenhuma",
  apprenticeHasDeductions: "2",
  apprenticeDeductionsDescription: "Nenhuma",
  apprenticeHasBenefits: "2",
  apprenticeBenefitsCalculation: "2",
  apprenticePayrollProcessing: "2",
  apprenticeFixedBenefit: "2",
  apprenticeFixedBenefitRubric: "Nenhuma",
  apprenticeFixedBenefitRule: "Nenhuma",
  apprenticeBenefitValue: "1",
  apprenticeProportionalCalcRule: "1",
  apprenticeProportionalCalcRuleOther: "Nenhuma",
  hasAutonomous: "2",
  autonomousBusinessRule: "Nenhuma",
  hasProLabore: "2",
  proLaboreSalaryAdjustmentRule: "1",
  proLaboreSalaryAdjustmentOther: "Nenhuma",
  proLaboreHasFgtsNoLink: "2",
  payrollAnalyticalReportOrder: "1",
  payrollSyntheticReportOrder: "1",
  payrollNetReport: "1",
  payrollNetReportExcel: "1",
  payrollAccountingSyntheticReportOrder: "1",
  hasDomesticEmployee: "2",
  domesticEmployeeSalaryAdjustmentRule: "1",
  domesticEmployeeSalaryAdjustmentRuleOther: "Nenhuma",
  domesticEmployeeWorkTimeControl: "1",
  domesticEmployeeClosePeriod: "1",
  domesticEmployeeClosePeriodOther: "Nenhuma",
  hasSpecificWageItems: "2",
  specificWageRows: {},
  hasCustomWageIncidences: "2",
  customWageRows: {},
  hasHazardPay: "2",
  hasInsalubrityPay: "2",
  discountAdditionalOnAbsence: "2",
  proportionalRuleForDifferentMonthDays: "1",
  otherExclusiveRules: "2",
  otherExclusiveRulesDescription: "Nenhuma",

  benefitsIsValidated: false,
  hasLifeInsurance: "2",
  lifeInsuranceMovementType: "1",
  lifeInsuranceMovementReport: "2",
  lifeInsuranceMovementReportDeadline: "Não há",
  lifeInsuranceDiscountValue: "1",
  lifeInsuranceDiscountValueFix: "10,00",
  lifeInsuranceDiscountValueSalaryPercentage: "1",
  lifeInsuranceDiscountValueOther: "Nenhuma",
  lifeInsuranceCompanyCost: "50",
  lifeInsuranceEmployeeCost: "50",
  lifeInsuranceProLabore: "2",
  lifeInsuranceIntern: "2",
  lifeInsuranceApprentice: "2",
  lifeInsuranceOnLeave: "2",
  lifeInsuranceDiscountOnPayroll: "2",
  lifeInsuranceDiscountOnPayrollOther: "Nenhuma",
  lifeInsuranceDiscountInTermination: "2",
  lifeInsuranceOtherRules: "2",
  lifeInsuranceOtherRulesDescription: "Nenhuma",
  hasHealthPlan: "2",
  healthPlanOperators: [
    {
      name: "Operadora Teste", cnpj: "49.718.808/0001-06", ansCode: "12345", type: "1", companyCost: "50", employeeCost: "50",
      dependentCost: "50", aggregateCost: "50", hasCoparticipation: "2",
      companyCoparticipationCost: "50", employeeCoparticipationCost: "50",
      dependentCoparticipationCost: "50", aggregateCoparticipationCost: "50",
      coparticipationRule: "2", coparticipationRuleDescription: "Nenhuma",
      beneficiariesOutsideEmployees: "2", beneficiariesOutsideEmployeesDescription: "Nenhuma",
      reportReceptionDate: "Dia 20", adjustmentDate: "Dezembro",
    },
  ],
  healthPlanDiscountOnPayroll: "2",
  healthPlanDiscountOnPayrollOther: "Nenhuma",
  healthPlanDiscountInTermination: "2",
  healthPlanOtherRules: "2",
  healthPlanOtherRulesDescription: "Nenhuma",
  hasDentalPlan: "2",
  dentalPlanOperators: [
    {
      name: "Odonto Teste", cnpj: "49.718.808/0001-06", ansCode: "12345", type: "1", companyCost: "50", employeeCost: "50",
      dependentCost: "50", aggregateCost: "50",
      beneficiariesOutsideEmployees: "2", beneficiariesOutsideEmployeesDescription: "Nenhuma",
      reportReceptionDate: "Dia 20", adjustmentDate: "Dezembro",
    },
  ],
  dentalPlanDiscountOnPayroll: "2",
  dentalPlanDiscountOnPayrollOther: "Nenhuma",
  dentalPlanDiscountInTermination: "2",
  dentalPlanOtherRules: "2",
  dentalPlanOtherRulesDescription: "Nenhuma",
  hasTransportationVoucher: "2",
  transportationOperatorName: "SPTrans",
  transportationCalculationPeriod: "Mensal",
  transportationDeductionPeriod: "Mensal",
  transportationCalcExecution: "1",
  transportationPurchaseDeadline: "Dia 20",
  transportationDeductAbsences: "2",
  transportationDeductMedicalCertificates: "2",
  transportationBenefitForAccidentLeave: "2",
  transportationAccidentLeaveLimit: "Nenhum",
  transportationBenefitForAccidentLeaveOther: "Nenhum",
  transportationBenefitForIllnessLeave: "2",
  transportationBenefitForIllnessLeaveLimit: "Nenhum",
  transportationBenefitForIllnessLeaveOther: "Nenhum",
  transportationBenefitForMaternityLeave: "2",
  transportationBenefitForMaternityLeaveLimit: "Nenhum",
  transportationBenefitForMaternityLeaveOther: "Nenhum",
  transportationBenefitDuringVacation: "2",
  transportationOtherDeductionFactors: "2",
  transportationDeductionRuleDescription: "Nenhuma",
  transportationPayrollDeduction: "2",
  transportationPayrollDeductionOther: "Nenhuma",
  transportationTerminationDeduction: "2",
  transportationUnusedBenefitDeduction: "2",
  hasMobilityVoucher: "2",
  mobilityOperatorName: "SPTrans",
  mobilityCalculationPeriod: "Mensal",
  mobilityDeductionPeriod: "Mensal",
  mobilityCalcExecution: "1",
  mobilityPurchaseDeadline: "Dia 20",
  mobilityDeductAbsences: "2",
  mobilityDeductMedicalCertificates: "2",
  mobilityBenefitForAccidentLeave: "2",
  mobilityAccidentLeaveLimit: "Nenhum",
  mobilityBenefitForAccidentLeaveOther: "Nenhum",
  mobilityBenefitForIllnessLeave: "2",
  mobilityBenefitForIllnessLeaveLimit: "Nenhum",
  mobilityBenefitForIllnessLeaveOther: "Nenhum",
  mobilityBenefitForMaternityLeave: "2",
  mobilityBenefitForMaternityLeaveLimit: "Nenhum",
  mobilityBenefitForMaternityLeaveOther: "Nenhum",
  mobilityBenefitDuringVacation: "2",
  mobilityOtherDeductionFactors: "2",
  mobilityDeductionRuleDescription: "Nenhuma",
  mobilityPayrollDeduction: "2",
  mobilityPayrollDeductionOther: "Nenhuma",
  mobilityTerminationDeduction: "2",
  mobilityUnusedBenefitDeduction: "2",
  hasFoodVoucher: "2",
  foodOperatorName: "Alelo",
  foodCalculationPeriod: "Mensal",
  foodDeductionPeriod: "Mensal",
  foodCalcExecution: "1",
  foodPurchaseDeadline: "Dia 20",
  foodDeductAbsences: "2",
  foodDeductMedicalCertificates: "2",
  foodBenefitForAccidentLeave: "2",
  foodAccidentLeaveLimit: "Nenhum",
  foodBenefitForAccidentLeaveOther: "Nenhum",
  foodBenefitForIllnessLeave: "2",
  foodBenefitForIllnessLeaveLimit: "Nenhum",
  foodBenefitForIllnessLeaveOther: "Nenhum",
  foodBenefitForMaternityLeave: "2",
  foodBenefitForMaternityLeaveLimit: "Nenhum",
  foodBenefitForMaternityLeaveOther: "Nenhum",
  foodBenefitDuringVacation: "2",
  foodOtherDeductionFactors: "2",
  foodDeductionRuleDescription: "Nenhuma",
  foodPayrollDeduction: "2",
  foodPayrollDeductionOther: "Nenhuma",
  foodTerminationDeduction: "2",
  foodUnusedBenefitDeduction: "2",
  hasMealVoucher: "2",
  mealOperatorName: "Ticket",
  mealCalculationPeriod: "Mensal",
  mealDeductionPeriod: "Mensal",
  mealCalcExecution: "1",
  mealPurchaseDeadline: "Dia 20",
  mealDeductAbsences: "2",
  mealDeductMedicalCertificates: "2",
  mealBenefitForAccidentLeave: "2",
  mealAccidentLeaveLimit: "Nenhum",
  mealBenefitForAccidentLeaveOther: "Nenhum",
  mealBenefitForIllnessLeave: "2",
  mealBenefitForIllnessLeaveLimit: "Nenhum",
  mealBenefitForIllnessLeaveOther: "Nenhum",
  mealBenefitForMaternityLeave: "2",
  mealBenefitForMaternityLeaveLimit: "Nenhum",
  mealBenefitForMaternityLeaveOther: "Nenhum",
  mealBenefitDuringVacation: "2",
  mealOtherDeductionFactors: "2",
  mealDeductionRuleDescription: "Nenhuma",
  mealPayrollDeduction: "2",
  mealPayrollDeductionOther: "Nenhuma",
  mealTerminationDeduction: "2",
  mealUnusedBenefitDeduction: "2",
  hasBasicBasket: "2",
  basicBasketProvider: "Fornecedor",
  basicBasketCalculationPeriod: "Mensal",
  basicBasketBusinessRule: "Nenhuma",
  basicBasketPayrollDeduction: "2",
  basicBasketPayrollDeductionOther: "Nenhuma",
  basicBasketTerminationDeduction: "2",
  basicBasketUnusedBenefitDeduction: "2",
  hasCanteen: "2",
  canteenCalculationPeriod: "Mensal",
  canteenBusinessRule: "Nenhuma",
  canteenPayrollDeduction: "2",
  canteenPayrollDeductionOther: "Nenhuma",
  canteenTerminationDeduction: "2",
  canteenUnusedBenefitDeduction: "2",
  hasOtherBenefits: "2",
  otherBenefits: [{ description: "Nenhum", businessRule: "Nenhuma" }],
  hasPharmacy: "2",
  agreements: [{ description: "Nenhum", calculationPeriod: "Mensal", infoFormat: "1", reportDeadline: "Dia 20", payrollDeduction: "2", payrollDeductionOther: "Nenhuma", terminationDeduction: "2", unusedBenefitDeduction: "2" }],
  hasSocialSecurity: "2",
  socialSecurityUser: "Nenhum",
  socialSecurityPassword: "123",
  hasPowerOfAttorney: "2",
  eSocialPowerOfAttorneyExpirationDate: "2030-12-31",
  connectivityPowerOfAttorneyExpirationDate: "2030-12-31",
  employerWebPowerOfAttorneyExpirationDate: "2030-12-31",
};
